import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { Store } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { MatTableDataSource } from '@angular/material/table';
import {
    AlertModule,
    ButtonModule,
    ButtonColors,
    ButtonTypes,
    DropdownMenuItem,
    PopupModule,
} from '@ed---interne/ng-uui-components';

import {
    DisplayedColumns,
    DisplayType,
} from '../../../shared/components/ed-table/ed-table.component';
import { DocumentService } from '../../../core/services/document.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';

interface SettingsMenuItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

interface PropertyTableElement {
    id: string;
    folder: string;
    name: string;
    actions: DropdownMenuItem[];
}

@UntilDestroy()
@Component({
    selector: 'app-simulations',
    templateUrl: './simulations.component.html',
    styleUrls: ['./simulations.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, SharedModule, AlertModule, ButtonModule, PopupModule],
    providers: [DocumentService, Store],
})
export class SimulationsComponent implements OnInit {
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;

    public menuItems$: Observable<SettingsMenuItem[]> | undefined;

    constructor() {}

    public dataSource: MatTableDataSource<PropertyTableElement> =
        new MatTableDataSource<PropertyTableElement>();

    public displayedColumns: DisplayedColumns[] = [
        {
            displayType: DisplayType.TEXT,
            objectDisplayName: 'Dossier',
            objectKey: 'folder',
        },
        {
            displayType: DisplayType.TEXT,
            objectDisplayName: 'Nom du fichier',
            objectKey: 'name',
        },
    ];

    ngOnInit() {
        this.menuItems$ = of(null).pipe(
            map(() => {
                const items = [
                    {
                        display: 'Simuler un nouveau réseau',
                        routerLink: ['./new-network'],
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        display: `Simuler à partir d'un tracé existant`,
                        routerLink: ['./existing-network'],
                        routerLinkActiveOptions: { exact: false },
                    },
                ];
                return items;
            }),
            untilDestroyed(this),
        );
    }
}
